import React from 'react';
import { DescriptionList } from '@vwfs-bronson/bronson-react';
import { DefinitionListItemTitle } from '../DefinitionListItemTitle';
import { DefinitionListItem } from '../types';

export type DefinitionListHorizontalType = {
    list: DefinitionListItem[];
    className?: string;
    testId?: string;
    shortTerms?: boolean;
    children?: React.ReactNode;
};

export const DefinitionListHorizontal: React.FC<DefinitionListHorizontalType> = ({
    list,
    className,
    testId,
    shortTerms,
}) => {
    if (!list || list.length === 0) {
        return null;
    }

    return (
        <DescriptionList className={className} testId={testId} shortTerms={shortTerms} horizontal>
            {list.map((item: DefinitionListItem, index) => {
                const title = (
                    <DefinitionListItemTitle title={item.label} tooltip={item.tooltip} labelId={item.labelId} />
                );
                return (
                    <DescriptionList.Group testId={item.testId} key={index} termText={title}>
                        <DescriptionList.Detail>
                            {/*Workaround is necessary as Bronson does not have a proper spacing when the value dd has no content*/}
                            {item.value ? (
                                <span className={item.uppercaseValue ? 'u-text-uppercase' : ''}>{item.value}</span>
                            ) : (
                                <span
                                    dangerouslySetInnerHTML={{ __html: '&nbsp;' }}
                                    data-testid={item.testId + 'Value'}
                                />
                            )}
                        </DescriptionList.Detail>
                    </DescriptionList.Group>
                );
            })}
        </DescriptionList>
    );
};
